import { Icon } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import "./window.css";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const WindowMenu = ({ icon, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Icon sx={{ color: "#fff !important" }}>{icon}</Icon>
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: "20ch",
            background: "transparent",
            marginTop: "-10px"
          }
        }}
      >
        {children(handleClose)}
      </Menu>
    </div>
  );
};

const Window = ({
  options = [],
  contentCenter = false,
  contentStyles = {},
  sx = {},
  icon,
  title,
  children,
  subWindow,
  contentHidden = false,
  noScroll = false,
  id = Math.random()
}) => {
  const [open, setOpen] = useState(true);
  const ref = useRef();
  if (contentCenter)
    contentStyles = {
      ...contentStyles,
      ...{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    };

  if (noScroll) {
    contentStyles["overflow"] = "hidden";
  }
  useEffect(() => {
    const handleEvent = event => {
      if (
        ref?.current?.classList?.contains("minimized") &&
        event?.detail?.open
      ) {
        toggleWindow();
      }
    };

    window.addEventListener(`${id}-event`, handleEvent);

    return () => window.removeEventListener(`${id}-event`, handleEvent);
  }, []);
  const toggleWindow = () => {
    if (ref?.current?.classList?.contains("minimized")) {
      setOpen(true);
      ref?.current?.classList?.remove("minimized");
    } else {
      setOpen(false);

      ref?.current?.classList?.add("minimized");
    }
  };
  return (
    <div
      id={id}
      ref={ref}
      style={typeof sx === "function" ? sx(open) : sx}
      className="window"
    >
      <div className="window-header">
        <div className={`window-header-title ${subWindow ? "small" : "large"}`}>
          <Icon style={{ color: "#fff" }}>{icon}</Icon>
          <span>{title?.toUpperCase()}</span>
        </div>
        <div className="window-header-options">
          {options?.map((o, i) => {
            if (o?.menu) {
              return <WindowMenu key={i} {...o} />;
            }
            return (
              <Icon
                key={i}
                onClick={e => o.onClick(e, { toggleWindow })}
                style={{ color: "#fff" }}
              >
                {typeof o?.icon === "string" ? o?.icon : o?.icon(open)}
              </Icon>
            );
          })}
        </div>
      </div>
      {!contentHidden ? (
        <div className="window-content" style={contentStyles}>
          {typeof children === "function"
            ? children({ toggleWindow })
            : children}
        </div>
      ) : null}
    </div>
  );
};

export default Window;
